function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0,0h24v24H0V0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_669_2_",
  fill: "currentColor",
  d: "M8.2,14.7h2.5v-2.5h1.7l-3-3l-3,3h1.7L8.2,14.7z M6.5,15.6h5.9v0.9H6.5V15.6z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10.7,17.6H4.7V3.8h5.6v4h4v4.3h1.6V7l-4.8-4.8H4.7c-0.9,0-1.6,0.7-1.6,1.6l0,13.8c0,0.9,0.7,1.6,1.6,1.6h6.1 V17.6z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_687_3_",
  fill: "currentColor",
  d: "M12.6,14.7c0.4-0.4,0.7-0.7,0.9-0.6c0.3,0.1,0,0.5-0.2,0.8c-0.1,0.2-1.4,2-1.4,3.2 c0,0.6,0.2,1.1,0.7,1.5c0.4,0.3,0.9,0.4,1.3,0.2c0.5-0.2,1-0.7,1.5-1.4c0.6-0.8,1.4-1.7,2.1-1.7c0.8,0,0.8,0.5,0.9,0.9 c-1.4,0.2-2.5,1.3-2.7,2.7c0,0.9,0.7,1.6,1.6,1.6c0.8,0,2.2-0.7,2.4-3.1h1.2v-1.3h-1.2c0-1.1-0.9-2.1-2-2.1c-1,0.1-1.9,0.6-2.5,1.4 c-0.3,0.4-1,1.2-1.2,1.4c-0.1,0.2-0.3,0.4-0.6,0.4s-0.4-0.4-0.2-1c0.2-0.6,0.6-1.2,0.9-1.8c0.4-0.5,0.6-1,0.7-1.6 c0.1-0.7-0.5-1.4-1.2-1.4c0,0,0,0-0.1,0c-0.5,0-1,0.3-1.4,0.6c-0.2,0.2-0.3,0.3-0.4,0.5L12.6,14.7z M17.3,20.6 c-0.2,0-0.4-0.2-0.4-0.4c0.2-0.7,0.7-1.3,1.4-1.4C18.3,20.2,17.7,20.6,17.3,20.6L17.3,20.6z"
});

var SvgIconZegalSignTeal = function SvgIconZegalSignTeal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconZegalSignTeal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-zegal-sign--teal.af491933.svg";
export { ForwardRef as ReactComponent };